<template>
    <div>
        <div class="fee">
            <div class="fee-title">
                费率表
            </div>
        </div>
        <div class="sub-title">费率：是指您为货物价值投保时需要支付的保费，“保费=货物价值（即：保额）× 费率”。</div>
        <img src="../assets/feilv.png" alt="" class="feilv">
        <!--        <table class="basic" cellpadding="0" cellspacing="0">-->
        <!--            <tr>-->
        <!--                <td>货物类型</td>-->
        <!--                <td>-->
        <!--                    费率-->
        <!--                </td>-->
        <!--            </tr>-->
        <!--            <tr>-->
        <!--                <td >普货</td>-->
        <!--                <td>-->
        <!--                    万分之0.6至万分之1.2-->
        <!--                </td>-->
        <!--            </tr>-->
        <!--             <tr>-->
        <!--                <td >散货</td>-->
        <!--                <td>-->
        <!--                    万分之0.6至万分之1-->
        <!--                </td>-->
        <!--            </tr>-->
        <!--            <tr>-->
        <!--                <td>易碎易损品</td>-->
        <!--                <td>-->
        <!--                    万分之2至万分之3-->
        <!--                </td>-->
        <!--            </tr>-->
        <!--            <tr>-->
        <!--                <td>生鲜及冷藏品</td>-->
        <!--                <td>-->
        <!--                    万分之1.8至万分之2.5-->
        <!--                </td>-->
        <!--            </tr>-->
        <!--        </table>-->
        <!--        <div class="tips">-->
        <!--            注：未查到车辆北斗，按普货万1.2，生鲜万2.5，易碎万3的固定费率结算。-->
        <!--        </div>-->
    </div>
</template>

<script>
    export default {
        name: "Fee"
    }
</script>

<style scoped lang="scss">
    .fee {
        background: #ffffff;

        .fee-title {
            height: 12vw;
            padding-left: 5.67vw;
            line-height: 12vw;
            text-align: left;
            font-size: 4.27vw;
            font-weight: bold;
        }
    }

    .sub-title {
        padding: 0 5.67vw 3vw 5.67vw;
        line-height: 4vw;
        font-size: 3.2vw;
        background: #ffffff;
        text-align: left;
    }

    .feilv {
        width: 100vw;
        margin: 0 auto;
    }

    .basic {
        width: 100%;
        padding: 0 5.4vw 4vw;
        box-sizing: border-box;
        background: #ffffff;

        td {
            height: 8vw;
            line-height: 8vw;
            font-size: 3.2vw;
            border-left: .13vw solid #77ceff;
            border-bottom: .13vw solid #77ceff;
            box-sizing: border-box;
        }

        td:nth-child(2) {
            width: 37vw;
            padding: 0 2vw;
            text-align: left;
            border-right: .13vw solid #77ceff;
        }

        td:nth-child(1) {
            padding-left: 2vw;
            text-align: left;
        }

        tr:nth-child(1) td {
            border-top: .13vw solid #77ceff;
            background: #dceaff
        }
    }

    .tips {
        /*height: 7vw;*/
        padding: 0 0 2vw 5.67vw;
        text-align: left;
        font-size: 3.2vw;
        background: #ffffff;
        color: #ff9000;
    }
</style>